module.exports = __webpack_public_path__ + "static/1304365314.947e46b2.jpg";